module.exports = __webpack_public_path__ + "img/signal4.e3e84dbc.svg";